import { render, staticRenderFns } from "./OrderStatistics.vue?vue&type=template&id=8f659116&scoped=true"
import script from "./OrderStatistics.vue?vue&type=script&lang=js"
export * from "./OrderStatistics.vue?vue&type=script&lang=js"
import style0 from "./OrderStatistics.vue?vue&type=style&index=0&id=8f659116&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f659116",
  null
  
)

export default component.exports